import { MemberResponse } from "../contracts/MemberResponse";
import { Member } from "../models/Member";
import { GroupResponseMapper } from "./GroupResponseMapper";

const groupMapper = new GroupResponseMapper();

/** Maps API member responses to frontend Member models */
export class MemberResponseMapper {
  /** Converts a single MemberResponse to a Member model */
  toMember = (response: MemberResponse): Member => {
    return {
      id: response.id,
      organizationId: response.organizationId,
      instructorId: response.instructorId,
      firstName: response.firstName,
      lastName: response.lastName,
      email: response.email,
      primaryLanguageCode: response.primaryLanguageCode,
      currency: response.currency,
      notes: response.notes,
      address: response.address,
      dateOfBirth: response.dateOfBirth,
      guardianMemberId: response.guardianMemberId,
      isMinor: response.isMinor,
      deletedAt: response.deletedAt !== null ? new Date(response.deletedAt) : null,
      tags: response.tags ?? [],
      groups: response.groups !== null ? response.groups.map((g) => groupMapper.toGroup(g)) : [],
      dateCreated: new Date(response.dateCreated),
      dateModified: new Date(response.dateModified),
      messagesStoppedAt: response.messagesStoppedAt ? new Date(response.messagesStoppedAt) : null,
    };
  };

  /** Converts an array of MemberResponse to Member models */
  toMembers = (responses: MemberResponse[]): Member[] => {
    return responses.map((response) => this.toMember(response));
  };
}
